import React, { useState } from "react";
import "../css/about.css";

const About = () => {
  return (
    <div className="container mb-5">
      <div className="about-header">About Me</div>
      <p>
        I am a full stack developer who has worked on both inherited and new projects in many different languages and frameworks.
        My first project was in middle school: an Android application to help track health, cards, counters, etc. while playing Magic: The Gathering.
        My favorite part of coding is backend and data manipulation - I could happily design relational databases and write complex SQL queries all day.
      </p>
      <p>
        I did create this website myself using ReactJS + TypeScript.
        There is no backend, as the amount of data required is small, mostly static, and not expected to grow significantly.
      </p>
      <p>
        Outside of work, my hobbies include video games and cosplay. 
        My favorite cosplays so far are two characters - Felis and Devil's Advocate - from a game called Hunt: Showdown.
        I enjoy the process of problem-solving that comes along with recreating a character's design.
      </p>
      <div className="d-flex gap-2">
        <img className="w-50" src="/images/about/cosplay.jpg"/>
        <img className="w-50" src="/images/about/cosplay2.jpg"/>
      </div>
      <p>
        I also enjoy experimenting with various forms of art, including most types of traditional media as well as digital media (Photoshop, Illustrator, video editing, animation, 3D modeling).
      </p>
      <div className="d-flex gap-2">
        <img className="w-50" src="/images/about/art.jpg"/>
        <img className="w-50" src="/images/about/art2.jpg"/>
      </div>
      <p>
        As an animal lover, I have three cats, all of which are rescues. 
        I have volunteered with many area shelters and organizations, and I currently foster for <a href="https://therescueproject.net/" target="_blank" rel="noreferrer">The Rescue Project</a>.
        (One of my three cats is a foster fail!)
      </p>
      <div className="d-flex gap-2">
        <img className="w-50" src="/images/about/echo.jpg"/>
        <img className="w-50" src="/images/about/foster.jpg"/>
      </div>
      <p>
        Want to learn more about my background and experiences? Contact me at <a href="mailto:avarady94@gmail.com">avarady94@gmail.com</a>.
      </p>
    </div>
  );
};

export default About;
